import { SerialNumberElasticDto } from "../models"
import { FetchSerialNumberListingParams, SERIAL_NUMBER_ACTION_TYPES } from "./types"

export const clearSerialNumberListing = () =>
    ({
        type: SERIAL_NUMBER_ACTION_TYPES.CLEAR_SERIAL_NUMBER_LISTING
    })

export const fetchSerialNumberListing = (payload: FetchSerialNumberListingParams) => {
    return {
        type: SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING,
        payload: payload,
    }
}

export const fetchSerialNumberListingSuccess = (data: Array<SerialNumberElasticDto>) =>
    ({
        type: SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING_SUCCESS,
        payload: data
    })

export const fetchSerialNumberListingError = (data: { errorMessage: string }) =>
    ({
        type: SERIAL_NUMBER_ACTION_TYPES.FETCH_SERIAL_NUMBER_LISTING_ERROR,
        payload: data.errorMessage
    })


// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/actions/actions.ts